// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-885247d2] .v-application--wrap{min-height:inherit}.mono[data-v-885247d2]{font-family:monospace}", ""]);
// Exports
module.exports = exports;
